var render = function render(){var _vm=this,_c=_vm._self._c;return _c('object',{attrs:{"id":"controller-status-svg","onload":_vm.loaded(),"data":_vm.image,"type":"image/svg+xml","height":_vm.size,"width":_vm.size}})
}
var staticRenderFns = []

export { render, staticRenderFns }